import request from "@/modules/huyu-framework/backend/utils/request";

// 查询模块配置列表
export function listprojectConfig(query) {
  query.noVerification = true;
  return request({
    url: "/system/projectConfig/list",
    method: "get",
    params: query,
  });
}

// 查询模块配置详细
export function getprojectConfig(configId) {
  return request({
    url: "/system/projectConfig/" + configId,
    method: "get",
  });
}

// 新增模块配置
export function addprojectConfig(data) {
  return request({
    url: "/system/projectConfig",
    method: "post",
    data: data,
  });
}

// 修改模块配置
export function updateprojectConfig(data) {
  return request({
    url: "/system/projectConfig",
    method: "put",
    data: data,
  });
}
// 删除模块配置
export function delprojectConfig(data) {
  return request({
    url: "/system/projectConfig/delete",
    method: "post",
    data: data,
  });
}

// // 删除模块配置
// export function delprojectConfig(configId,data) {
//   return request({
//     url: '/projectConfig/projectConfig/' + configId,
//     method: 'delete',
//     data: data
//   })
// }
